import { render, staticRenderFns } from "./messorder.vue?vue&type=template&id=62058303"
import script from "./messorder.vue?vue&type=script&lang=js"
export * from "./messorder.vue?vue&type=script&lang=js"
import style0 from "./messorder.vue?vue&type=style&index=0&id=62058303&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports